function setCookie(name, value, maxAge) {
  var date = new Date();
  date.setTime(date.getTime() + maxAge);
  var expires = "expires=".concat(date.toUTCString());
  document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/");
}

export { setCookie };
